import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Splash from "../pages/splash/page";
import Welcome from "../pages/welcome/page";
import Login from "../pages/login/page";
import Home from "../pages/home/page";
import Exams from "../pages/exams/page";
import ExamDetails from "../pages/exam-details/page";
import Exam from "../pages/exam/page";
import ExamResult from "../pages/exam-result/page";
import Results from "../pages/results/page";
import Profile from "../pages/profile/page";
import TeacherDashboard from "../pages/teacher-dashboard/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Splash />,
  },
  {
    path: "/welcome",
    element: <Welcome />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/exams",
    element: <Exams />,
  },
  {
    path: "/exam-details/:id",
    element: <ExamDetails />,
  },
  {
    path: "/exam/:id",
    element: <Exam />,
  },
  {
    path: "/exam-result/:id",
    element: <ExamResult />,
  },
  {
    path: "/results",
    element: <Results />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/teacher-dashboard",
    element: <TeacherDashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
